import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// leaflet
import L from 'leaflet';
import {
  Map, LayersControl, TileLayer,
} from 'react-leaflet';
import FullscreenControl from 'react-leaflet-fullscreen';
import { GestureHandling } from 'leaflet-gesture-handling';

import { useTranslation } from 'react-i18next';

// layers
import WmsBoundary from '../../../components/map/WmsBoundary';
import WmsBasin from '../../../components/map/WmsBasin';
import LayerProvince from '../../../components/map/Province';
import LayerRiver from '../../../components/map/River';
import LayerAmphoe from '../../../components/map/Amphoe';
import LeafletFullScreenFix from '../../../utils/map/LeafletFullScreenFix';

// components
import mapConfig from '../../../components/map/Config';

const { Overlay } = LayersControl;

export default function MapRisk(props) {
  const { t } = useTranslation();
  const refMap = useRef(null);
  const {
    currentArea,
    riskAreasId,
  } = props;

  useEffect(() => {
    // set bounds
    if (currentArea.top_left) {
      refMap.current.leafletElement.fitBounds(
        L.latLngBounds(currentArea.top_left, currentArea.bottom_right), { padding: [50, 50] },
      );
    }

    // add map gesture zoom
    L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
  }, [currentArea]);

  return (
    <>
      <Map
        id="map"
        center={currentArea.location ? currentArea.location : mapConfig.center}
        // zoom={currentArea.zoom ? currentArea.zoom : mapConfig.zoom}
        zoomSnap={0}
        zoomDelta={0.5}
        ref={refMap}
        style={{ height: 700 }}
        boundsOptions={{ padding: [50, 50] }}
        gestureHandling
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          id="OpenStreetMap"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>ESRI World Street Map</a> contributors"
        />
        <LayerProvince
          areaType={0}
          areaId={currentArea.code}
        />
        <LayerAmphoe
          areaType={0}
          riskAreasId={riskAreasId}
        />
        <LayersControl position="topright">
          <Overlay name={t('เส้นแม่น้ำ')} checked>
            <LayerRiver />
          </Overlay>
          <Overlay name={t('ขอบเขตการปกครอง')}>
            <WmsBoundary />
          </Overlay>
          <Overlay name={t('ขอบเขตลุ่มน้ำ')}>
            <WmsBasin />
          </Overlay>
        </LayersControl>
        <FullscreenControl
          position="topleft"
          forcePseudoFullscreen
          content={LeafletFullScreenFix()}
        />
      </Map>
    </>
  );
}

MapRisk.propTypes = {
  currentArea: PropTypes.instanceOf(Object).isRequired,
  riskAreasId: PropTypes.instanceOf(Array).isRequired,
};
